import { render, staticRenderFns } from "./NEOLinkGroupsDialog.vue?vue&type=template&id=55bd5622&scoped=true&"
import script from "./NEOLinkGroupsDialog.vue?vue&type=script&lang=js&"
export * from "./NEOLinkGroupsDialog.vue?vue&type=script&lang=js&"
import style0 from "./NEOLinkGroupsDialog.vue?vue&type=style&index=0&id=55bd5622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd5622",
  null
  
)

export default component.exports